import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicSearchTabNav from './EpicSearchTabNav/epic.search.tab.nav.vue';
import { findComponentsDownward } from '../../utils/assist';
import { ESearchBarFeatures } from '../../models/searchbar.features';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../utils/axios.promise';
import * as T_T from 'cryface';
import { Models } from '../../models/models';
import { SpringSpinner } from 'epic-spinners';

@Component({
    components: {
        EpicSearchTabNav,
        SpringSpinner,
    }
})
export default class EpicSearchBar extends Vue {
    public title: string = 'EpicSearchBar';

    public configs: any = new CommonConfig();

    public navs: any[] = [];

    public dropdownShow = false;

    public searchText = '';

    // autoComplete
    public googleResult: any = null;

    public google: any = null;

    public googlePlaceResult: any = null;

    public isSelected = false;

    public navFeature: ESearchBarFeatures = ESearchBarFeatures.Buy;

    public requestTimeoutId: any = undefined;

    public mapCallbacks: any[] = [];

    public debounce = 800;

    public debounceCode: any;

    public isLoading = false;

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    @Watch('searchText', { immediate: true, deep: true })
    public async onSearchTextChange(val: any, oldVal: any) {
    }

    public getNavs() {
        const navs: any = findComponentsDownward(this, 'EpicSearchTabNav');
        this.navs = navs;
        this.navs.map((nav: any) => {
            nav.$on('rifo-click', () => {
                this.navClicked(nav);
            });
        });
        // console.log(navs);
    }

    public async mounted() {
        this.getNavs();
        this.navs[0].eActive = true;
    }

    public navClicked(nav: any) {
        if (this.navFeature === nav.feature) {
        } else {
            this.navFeature = nav.feature;
            this.clearSearchbar();
            this.navs.map((n: any) => {
                if (this.navs.indexOf(nav) === this.navs.indexOf(n)) {
                    n.eActive = true;
                } else {
                    n.eActive = false;
                }
            });
        }
    }

    public keyboardWatch(event: any) {
        const text = this.searchText;
        clearTimeout(this.requestTimeoutId);
        if (T_T.simpleDetect(text)) {
            this.requestTimeoutId = setTimeout(async () => {
                // get Dropdown Content
                switch (this.navFeature) {
                    case ESearchBarFeatures.Buy: {
                        await this.autoByAddress(text);
                        break;
                    }
                    case ESearchBarFeatures.Rent: {
                        await this.autoByAddress(text);
                        break;
                    }
                    case ESearchBarFeatures.FindAgents: {
                        break;
                    }
                    case ESearchBarFeatures.HomeService: {
                        break;
                    }
                    case ESearchBarFeatures.PropertyValue: {
                        await this.autoByAddress(text);
                        break;
                    }
                }
                // DropDown Show
                this.dropdownShow = true;
            }, 300);
        }
    }

    public async autoByAddress(text: string) {
        if (text.length > 0) {
            this.googleResult = await this.autoCompleteGoogle();
        } else {
            this.googleResult = null;
            this.dropdownShow = false;
        }
    }

    public clearSearchbar() {
        this.searchText = '';
        this.googleResult = null;
        this.dropdownShow = false;
    }

    public async autoCompleteGoogle() {
        const apiHost = this.configs.analysisService;
        const google = `${apiHost}/google/autocomplete?searchtext=${this.searchText}`;
        const fetched = await AxiosPromise.get(google);
        if (fetched.code === 200) {
            return this.autoCompleteDataClean(fetched.data);
        }
        return null;
    }

    public autoCompleteDataClean(dataGotten: any) {
        return T_T.simpleDetect(dataGotten.predictions) ? dataGotten.predictions : [];
    }

    public dropDownOutside() {
        this.dropdownShow = false;
    }

    public onDropdownSelected(text: string) {
        this.searchText = text;
        this.dropdownShow = false;
    }

    public getTitle() {
        switch (this.navFeature) {
            case ESearchBarFeatures.Buy: {
                return 'Search Properties For Sale';
                break;
            }
            case ESearchBarFeatures.Rent: {
                return 'Search Properties For Lease';
                break;
            }
            case ESearchBarFeatures.FindAgents: {
                return 'Search Agents';
                break;
            }
            case ESearchBarFeatures.HomeService: {
                return 'Search Home Services';
                break;
            }
            case ESearchBarFeatures.PropertyValue: {
                return 'Search Properties By The Address';
                break;
            }
        }
    }

    public getPlaceHolder() {
        switch (this.navFeature) {
            case ESearchBarFeatures.Buy: {
                return `Property address / MLS number`;
                break;
            }
            case ESearchBarFeatures.Rent: {
                return `Property address / MLS number`;
                break;
            }
            case ESearchBarFeatures.FindAgents: {
                return 'Search for agents';
                break;
            }
            case ESearchBarFeatures.HomeService: {
                return 'Search for home services';
                break;
            }
            case ESearchBarFeatures.PropertyValue: {
                return 'Search for properties by the address';
                break;
            }
        }
    }

    public handleSearch() {
        clearTimeout(this.debounceCode);
        this.isLoading = true;
        this.mapCallbacks.map((cb: any) => {
            cb();
        });
        this.debounceCode = setTimeout(async () => {
            switch (this.navFeature) {
                case ESearchBarFeatures.Buy: {
                    const newFilters: Models.IMapListSimpleFilters = Models.initMapListSimpleFilters();
                    newFilters.filterSimpleListingTypes = ['For Sale'];
                    this.navToMap(newFilters);
                    break;
                }
                case ESearchBarFeatures.Rent: {
                    const newFilters: Models.IMapListSimpleFilters = Models.initMapListSimpleFilters();
                    newFilters.filterSimpleListingTypes = ['For Rent'];
                    this.navToMap(newFilters);
                    break;
                }
                case ESearchBarFeatures.FindAgents: {
                    break;
                }
                case ESearchBarFeatures.HomeService: {
                    break;
                }
                case ESearchBarFeatures.PropertyValue: {
                    const newFilters: Models.IMapListSimpleFilters = Models.initMapListSimpleFilters();
                    this.navToMap(newFilters);
                    break;
                }
            }
            this.isLoading = false;
        }, this.debounce);
    }

    public async navToMap(filters: Models.IMapListSimpleFilters) {
        if (this.searchText === '') {
            this.searchText = 'Toronto';
            // location.href = '/map';
        }
        if (T_T.simpleDetect(this.searchText)) {
            this.googlePlaceResult = await this.getPlacesGoogle();
        }
        if (this.googlePlaceResult) {
            const geometry = this.googlePlaceResult.geometry;
            if (T_T.simpleDetect(geometry)) {
                if (T_T.simpleDetect(geometry.location)) {
                    this.$store.commit('setCenter', geometry.location);
                }
                const mapFetchingCallback: any = this.$Message.loading({
                    content: 'Loading, Please Wait...',
                    duration: 0
                });
                this.mapCallbacks.push(mapFetchingCallback);
                await this.$store.dispatch('addressSearch', {
                    googleVal: this.googlePlaceResult,
                    mapFetchingCallback: mapFetchingCallback,
                    filters: filters
                });
                this.$router.push('/map');
            }
        }
        if (!this.googlePlaceResult
            && /^[A-Za-z][0-9]{7}$/.test(this.searchText.trim())
        ) {
            // Format Match MLS number
            const mlsNumber = this.searchText.trim();
            await this.$store.dispatch('MLSNumberSearch', mlsNumber);
            this.$router.push('/map');
        }
    }


    public async getPlacesGoogle() {
        const apiHost = this.configs.analysisService;
        const google = `${apiHost}/google/places?searchtext=${this.searchText}`;
        const fetched = await AxiosPromise.get(google);
        if (fetched.code === 200) {
            if (T_T.simpleDetect(fetched.data.candidates)) {
                if (fetched.data.candidates.length > 0) {
                    return fetched.data.candidates[0];
                }
            }
        }
        return null;
    }
}
